import React, { Component } from 'react';

import PropTypes from 'prop-types';

import Header from '../../../navigation/header/header.js';

import PaymentNoticeListView from '../../../components/myquote/payment-notice/payment-notice-list-view.js';

class PaymentNoticeListScreen extends React.Component {
	constructor(props) {
		super(props);
		
		this.app = this.props.app;
		this.getMvcModuleObject = this.app.getMvcModuleObject;
		this.getMvcMyQuoteObject = this.app.getMvcMyQuoteObject;
		
		this.uuid = this.app.guid();
		
		
		this.state = {
			action: 'create',
			txhash: null,
			loaded: false,
			quoteinfo: 'loading...'
		};
	}
	
	// post render commit phase
	componentDidMount() {
		console.log('PaymentNoticeListScreen.componentDidMount called');
		
		this.checkNavigationState().catch(err => {console.log('error in checkNavigationState: ' + err);});
	}

	async checkNavigationState() {
		let mvcmodule = this.getMvcModuleObject();
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;

		let app_nav_state = this.app.getNavigationState();
		let app_nav_target = app_nav_state.target;

		if (app_nav_target && (app_nav_target.route == 'quote') && (app_nav_target.reached == false)) {
			var params = app_nav_target.params;

			if (params) {
				let txhash = params.txhash;
				let quoteinfo = '';
				let action = (params.action ? params.action : 'create');
	
				if (txhash) {
					// retrieve info from firenze
					quoteinfo = txhash;
				}
	
				this.setState({action, txhash, quoteinfo});
			}

			// QuoteView will take care of marking target reached
		}

		this.setState({loaded: true});
	}
	
	// end of life
	componentWillUnmount() {
		console.log('PaymentNoticeListScreen.componentWillUnmount called');
		let app = this.app;
		let mvcmodule = app.getMvcModuleObject();
		
	}
	
	
	render() {
		let {loaded, action, quoteinfo, txhash} = this.state;

		return (
			<div className="Screen">
				<Header app = {this.app} />
				{(loaded === true ?
				<PaymentNoticeListView app = {this.app} /> :
				<div>{quoteinfo}</div>
				)}
			</div>
		);
	}
}

// propTypes validation
PaymentNoticeListScreen.propTypes = {
	app: PropTypes.object.isRequired,
};



export default PaymentNoticeListScreen;